import { AuthConfig, authExchange } from '@urql/exchange-auth';
import { AxiosAuthRefreshRequestConfig } from 'axios-auth-refresh';
import { ClientOptions, createClient, fetchExchange, makeOperation } from 'urql';
import { AuthStorageService } from '../auth/auth-storage.service';
import { AuthResponse } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import { getHttpService } from './http.factory';
import qs from 'qs';
import { AUTH_TOKEN_URL } from '../auth/auth-constants';

const refreshtoken = async (): Promise<{ accessToken: string; refreshToken: string } | null> => {
  const data = AuthService.getRefreshTokenBody();
  try {
    const response = await getHttpService().post<AuthResponse, Record<string, string> | string>(AUTH_TOKEN_URL, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;',
      },
      skipAuthRefresh: true,
    } as AxiosAuthRefreshRequestConfig);

    AuthStorageService.clearPkceFlowData();
    return AuthStorageService.saveAuthResponse(response);
  } catch (e) {
    // invalid grant
    AuthStorageService.clearSession();
    AuthStorageService.clearPkceFlowData();
    AuthService.logIn();
  }
  return null;
};

const authOptions: AuthConfig<{ accessToken?: string; refreshToken?: string } | null> = {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS problems come with the library
  addAuthToOperation: ({ authState, operation }) => {
    if (!authState || !authState.accessToken) {
      return operation;
    }

    const fetchOptions =
      typeof operation.context.fetchOptions === 'function' ? operation.context.fetchOptions() : operation.context.fetchOptions || {};

    return makeOperation(operation.kind, operation, {
      ...operation.context,
      fetchOptions: {
        ...fetchOptions,
        headers: {
          ...fetchOptions.headers,
          Authorization: `Bearer ${authState.accessToken}`,
        },
      },
    });
  },
  getAuth: async ({ authState }) => {
    if (typeof window !== 'undefined') {
      if (!authState) {
        const accessToken = AuthStorageService.getAccessToken();
        const refreshToken = AuthStorageService.getRefreshToken();
        return accessToken && refreshToken ? { accessToken, refreshToken } : null;
      }

      return refreshtoken();
    }
    return null;
  },
  didAuthError: ({ error }) => {
    // TODO we should have this in the code field instead of title
    return error.graphQLErrors.some((e) => e.extensions?.title === 'UNAUTHORIZED');
  },
};

const _authExchange = authExchange(authOptions);

export const createGraphQLClient = (baseUrl: string, opts?: Partial<ClientOptions>) => {
  return createClient({
    url: baseUrl,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: TS problems come with the library
    exchanges: [_authExchange, fetchExchange],
    ...opts,
  });
};
